'use client';

import { useParams } from 'next/navigation';

import ButtonLink from '@/components/ui/ButtonLink';
import Text from '@/components/ui/Text';
import { COMMON_I18N } from '@/lib/i18n/commonI18n';
import { resolveAppLocale } from '@/lib/i18n/routing';

const NotFoundMessage = () => {
  const params = useParams();
  const locale = resolveAppLocale(params.locale as string);
  const i18n = COMMON_I18N[locale];

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center max-w-md px-8">
        <Text as="p" variant="sectionEyebrow" className="mb-3">
          404
        </Text>
        <Text as="h1" variant="sectionTitle" className="mb-4">
          {i18n.notFoundTitle}
        </Text>
        <Text as="p" variant="paragraph" className="mb-8">
          {i18n.notFoundMessage}
        </Text>
        <ButtonLink href="/" variant="primary">
          {i18n.backToHome}
        </ButtonLink>
      </div>
    </div>
  );
};

export default NotFoundMessage;
